// extracted by mini-css-extract-plugin
export default {"root":"brE9VfvYwiakndh4v6H9"};